import React, { useEffect, useRef, useState } from 'react';

export function ImageViewModalWithZoom({ src, alt, small=false, className=null, onError=null }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isZoomed, setIsZoomed] = useState(false);
  const thumbnailRef = useRef(null);
  const dialogRef = useRef(null);

  const openModal = () => {
    setIsModalOpen(true);
    setIsZoomed(false);
  };

  const toggleZoom = () => {
    setIsZoomed((prev) => !prev);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsZoomed(false);
    thumbnailRef.current?.focus();
  };

  useEffect(() => {
    if (isModalOpen) {
      dialogRef.current?.focus();
    }
  }, [isModalOpen]);

  const activateOnKey = (handler) => (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handler();
    }
  };

  return (
    <>
      <img
        ref={thumbnailRef}
        src={src}
        alt={alt}
        className={className ?? (small ? "zoomableThumbnailSmall" : "zoomableThumbnail")}
        tabIndex={0}
        aria-haspopup="dialog"
        onClick={openModal}
        onKeyDown={activateOnKey(openModal)}
        onError={onError ?? undefined}
      />
      {isModalOpen && (
        <div
          className="modalBackdrop"
          onClick={closeModal}
          onKeyDown={(e) => {
            if (e.key === 'Escape') closeModal();
          }}
        >
          <div
            ref={dialogRef}
            className="modalScrollContainer"
            role="dialog"
            aria-modal="true"
            aria-label={alt}
            tabIndex={-1}
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={src}
              alt={alt}
              className={small ? `modalImageSmall ${isZoomed ? 'zoomed' : ''}` :`modalImage ${isZoomed ? 'zoomed' : ''}`}
              tabIndex={0}
              onClick={toggleZoom}
              onKeyDown={activateOnKey(toggleZoom)}
            />
            <div className="modalMessage" role="status">{`Click to zoom ${isZoomed ? "out":"in"}`}</div>
          </div>
        </div>
      )}
    </>
  );
}
